import { render, staticRenderFns } from "./MyDayCard.vue?vue&type=template&id=e5244810"
import script from "./MyDayCard.vue?vue&type=script&lang=js"
export * from "./MyDayCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports